import { fetchAPI } from "./baseApi";

export async function getPublicationsAdmin() {
  return fetchAPI("/publications/admin", { method: "GET" });
}

export async function createPublication(data) {
  return fetchAPI("/publications/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updatePublication(id, data) {
  return fetchAPI(`/publications/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deletePublication(id) {
  return fetchAPI(`/publications/admin/${id}`, { method: "DELETE" });
}
